import React, { useState, useEffect } from "react";
import "../App.css";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

function Tournament({ initialSize = 16, user }) {
  const navigate = useNavigate();
  const [tournamentSize, setTournamentSize] = useState(initialSize);
  const [tournamentName, setTournamentName] = useState("");
  const [tournamentId, setTournamentId] = useState(null);
  const [entries, setEntries] = useState([]);
  const [decks, setDecks] = useState([]);
  const [localAssignments, setLocalAssignments] = useState({});

  const rounds = Math.min(Math.log2(tournamentSize), 7);

  const generateSeeding = (size) => {
    if (size === 1) return [1];
    const half = size / 2;
    const prev = generateSeeding(half);
    const res = [];
    prev.forEach((seed) => {
      res.push(seed);
      res.push(size + 1 - seed);
    });
    return res;
  };

  const seeding = generateSeeding(tournamentSize);

  useEffect(() => {
    const fetchDecks = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/data/snapDecks/user/${user.id}`
        );
        setDecks(res.data);
      } catch (err) {
        console.error("Error fetching decks:", err);
      }
    };
    if (user?.id) fetchDecks();
  }, [user]);

  const fetchEntries = async (id) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/tournament/${id}/entries`
      );
      setEntries(res.data);
    } catch (err) {
      console.error("Error fetching entries:", err);
    }
  };

  const generateWinnersBracket = () => {
    let bracket = [];
    let matches = tournamentSize / 2;
    let entryIndex = 0;
    for (let r = 1; r <= rounds; r++) {
      const roundMatches = [];
      for (let m = 1; m <= matches; m++) {
        const e1 = r === 1 ? entries[entryIndex] : null;
        const e2 = r === 1 ? entries[entryIndex + 1] : null;
        roundMatches.push({
          id: `W${r}-M${m}`,
          entry1: e1,
          entry2: e2,
          seed1: r === 1 ? seeding[entryIndex] : null,
          seed2: r === 1 ? seeding[entryIndex + 1] : null,
          round: r,
        });
        if (r === 1) entryIndex += 2;
      }
      bracket.push(roundMatches);
      matches = matches / 2;
    }
    return bracket;
  };

  return (
    <div className="drafts-panel">
      <h1 className="drafts-heading">Current Tournament</h1>
      <iframe className="button" src="https://brackethq.com/b/dbw8c/embed/" width="100%" height="850" frameborder="0"></iframe>
      <Link to="https://brackethq.com/" >
        <h2 className="button">Create Tournament</h2>
      </Link>
    </div>
  );
}

export default Tournament;
